'use client';
import { useRef, useEffect } from 'react';

const useInterval = (callbackFn, interval)=>{
    const callbackRef = useRef();
    useEffect(()=>{
        callbackRef.current = callbackFn;
    }, [
        callbackFn
    ]);
    useEffect(()=>{
        if (interval === null) {
            return;
        }
        const intervalId = setInterval(()=>{
            callbackRef.current == null ? void 0 : callbackRef.current.call(callbackRef);
        }, interval);
        return ()=>clearInterval(intervalId);
    }, [
        interval
    ]);
};

export { useInterval };
//# sourceMappingURL=useInterval.js.map
